import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  SimpleGrid,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import {
  FaCalendarAlt,
  FaExclamation,
  FaLightbulb,
  FaList,
  FaPlus,
} from "react-icons/fa";

import { PopupModal } from "react-calendly";
import AddEditRequirementModal from "../../ManageRequirements/AddEditRequirementModal";
import TaskTable from "../../ManageRequirements/Tasks/TaskTable";
import { useAuth } from "../../../Contexts/AuthContext";
import { useData } from "../../../Contexts/DataContext";

function Overview({ setTabIndex }) {
  const { currentUserDetails } = useAuth();
  const { enrichedTasks, selectedSow } = useData();

  const {
    isOpen: isViewModalOpen,
    onOpen: onViewModalOpen,
    onClose: onViewModalClose,
  } = useDisclosure();
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  const handleSwitchToTracker = (tabIndex) => {
    setTabIndex(tabIndex);
  };

  const myTasks = useMemo(
    () =>
      enrichedTasks.filter((t) => t.assignedToId === currentUserDetails?.id),
    [enrichedTasks, currentUserDetails]
  );

  console.log("currentUser", currentUserDetails);
  console.log("enrichedTasks", enrichedTasks);

  const QuickLinkCard = ({
    text,
    buttonLabel,
    icon,
    colorScheme = "gray",
    onClick,
    href, // Add optional href prop for mailto or links
  }) => {
    const Wrapper = href ? "a" : "div";

    return (
      <VStack
        as={Wrapper}
        href={href}
        target={href ? "_blank" : undefined}
        rel={href ? "noopener noreferrer" : undefined}
        spacing={2}
        align="center"
        justify="center"
        p={5}
        borderRadius="md"
        backdropFilter="blur(10px)"
        bg={"white"}
        boxShadow={"base"}
        transition="all 0.2s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
        minW={{ base: "100%", sm: "150px" }}
        maxW={{ base: "100%", sm: "250px" }}
        textAlign="center"
        flex={1}
        height="100%"
        onClick={href ? undefined : onClick}
        cursor={"pointer"}
        textDecoration="none"
      >
        <Box fontSize="2xl" color={`${colorScheme}.500`}>
          {icon}
        </Box>
        <Text fontWeight="medium" fontSize="sm">
          {text}
        </Text>

        <Button size="xs" variant="solid" colorScheme={colorScheme}>
          {buttonLabel}
        </Button>
      </VStack>
    );
  };

  return (
    <Box flex={1} w="100%" p={2} mx="auto" textAlign="center">
      <Flex direction="column" align="center">
        <Badge
          boxShadow={"md"}
          fontSize={"sm"}
          colorScheme="purple"
          mb={4}
          mt={-2}
        >
          {selectedSow?.projectName}
        </Badge>
        {/* <Heading color="black" fontSize="xl">
          Project Overview
        </Heading> */}
      </Flex>

      <HStack align="start" mb={8}>
        {/* Quick Links */}
        <VStack
          px={{ base: 4, md: 10 }}
          py={6}
          mx={"auto"}
          maxW="100%"
          borderRadius="xl"
          bgGradient="linear(to-r, #1b193e, blue.600)"
          spacing={4}
        >
          <Heading color="white" fontSize="lg">
            Quick Links
          </Heading>

          <SimpleGrid
            columns={{ base: 2, md: 3, lg: 5 }}
            spacing={4}
            width="100%"
            mt={4}
          >
            <QuickLinkCard
              text="Something not quite right?"
              buttonLabel="Report Issue"
              icon={<FaExclamation />}
              colorScheme="red"
              href="https://mail.google.com/mail/?view=cm&to=ryan.bentham@inovora.com&su=Issue"
            />

            <QuickLinkCard
              text="Request something new"
              buttonLabel="New Request"
              icon={<FaPlus />}
              colorScheme="yellow"
              onClick={onViewModalOpen}
            />

            <QuickLinkCard
              text="View development tracker"
              buttonLabel="Tracker"
              icon={<FaList />}
              colorScheme="green"
              onClick={() => handleSwitchToTracker(1)}
            />

            <QuickLinkCard
              text="Brainstorm  / new ideas"
              buttonLabel="Idea Board"
              icon={<FaLightbulb />}
              colorScheme="blue"
              onClick={() => handleSwitchToTracker(2)}
            />

            <QuickLinkCard
              text="Book time with Ryan"
              buttonLabel="Arrange Meeting"
              icon={<FaCalendarAlt />}
              colorScheme="purple"
              onClick={() => setIsCalendlyOpen(true)}
            />
          </SimpleGrid>
        </VStack>
      </HStack>

      {/* Modal */}
      {isViewModalOpen && (
        <AddEditRequirementModal
          isOpen={isViewModalOpen}
          onClose={onViewModalClose}
          type="new"
        />
      )}
      <PopupModal
        url="https://calendly.com/inovora-consultancy"
        rootElement={document.body}
        onModalClose={() => setIsCalendlyOpen(false)}
        open={isCalendlyOpen}
      />

      <TaskTable
        tasks={myTasks}
        maxH={"30vh"}
        user={currentUserDetails?.name}
        showOpenCompletedToggle={false}
      />
      <Button
        justifyContent={"flex-end"}
        size="xs"
        variant="outline"
        colorScheme="blue"
        onClick={() => handleSwitchToTracker(1)}
      >
        Go to Tracker
      </Button>
    </Box>
  );
}

export default Overview;
